import React, { useState } from 'react';
import MobileMoreMenuModal from './MobileMoreMenuModal';
import moreSvg from '../icon-list/raw-icons/more.svg';

const MobileMoreMenu = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <div className="bb-desktop:hidden">
      <button
        className="bg-bluebook-blue1"
        onClick={() => setIsModalOpen(true)}
      >
        <img
          aria-hidden="true"
          alt="More icon"
          src={moreSvg}
          className="bb-mobile:w-10 bb-mobile:h-10"
        />
      </button>
      {isModalOpen && (
        <MobileMoreMenuModal onClose={() => setIsModalOpen(false)} {...props} />
      )}
    </div>
  );
};

export default MobileMoreMenu;
